import {
    QUALIFICATION_FAILURE,
    QUALIFICATION_REQUEST,
    QUALIFICATION_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const qualificationListReducer = (state = initialState, action) => {
    const {type, data} = action;
    switch (type) {
        case QUALIFICATION_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case QUALIFICATION_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case QUALIFICATION_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
